import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import Card from "../../../../src/components/Card";
import { getApiCall, patchApiCall } from "../../../service/httpCall";
import { API_AGENT_ANNOUNCEMENT_EDIT, API_AGENT_ANNOUNCEMENT_SINGLE } from "../../../service/url";
import { ROUTES, STATUS } from "../../../utilities/constant";

const AgentAnnouncementEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [heading, setHeading] = useState("");
    const [content, setContent] = useState("");
    const [status, setStatus] = useState("");
    const [buttonDisable, setButtonDisable] = useState(false);

console.log("ID:", id);

    useEffect(() => {
        if (!id) return;

        const fetchUrl = API_AGENT_ANNOUNCEMENT_SINGLE.replace(':id', id);

        console.log("Fetching from URL:", fetchUrl);

        getApiCall(fetchUrl)
            .then(resp => {
                console.log("Full API Response:", resp);

                const data = resp?.data?.data || resp?.data || resp;

                if (data) {
                    setHeading(data.title || data.heading || "");
                    setContent(data.message || data.content || "");
                    setStatus(String(data.status || ""));
                }
            })
            .catch(err => {
                console.error("API Error Detail:", err.response || err);
                toast.error("can't load data");
            });
    }, [id]);


   const submitForm = () => {
        if (!id) {
            toast.error("ID missing!");
            return;
        }

        setButtonDisable(true);
        const url = API_AGENT_ANNOUNCEMENT_EDIT.replace(':id', id);
        
        const payload = { 
            heading, 
            content, 
            // status: Number(status) 
        };

        
        patchApiCall(url, payload)
            .then(() => {
                toast.success("Updated successfully");
                navigate(`/${ROUTES.AGENT_ANNOUNCEMENT.LIST}`);
            })
           .catch((err) => {
            const errorMsg = err|| "Update unsuccessfull";
            toast.error(errorMsg);
            setButtonDisable(false);
        });
    };

    return (
        <Card>
            <Card.Header><h4>Edit Announcement</h4></Card.Header>
            <Card.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Heading</Form.Label>
                        <Form.Control value={heading} onChange={(e) => setHeading(e.target.value)} />
                    </Form.Group>
                    {/* <Form.Group className="mb-3">
                        <Form.Label>Status</Form.Label>
                        <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                            {STATUS.map((val, idx) => <option key={idx} value={val.value}>{val.label}</option>)}
                        </Form.Select>
                    </Form.Group> */}
                    <Form.Group className="mb-3">
                        <Form.Label>Content</Form.Label>
                        <Form.Control as="textarea" rows={3} value={content} onChange={(e) => setContent(e.target.value)} />
                    </Form.Group>
                   <Button onClick={submitForm} disabled={buttonDisable}>
                        {buttonDisable ? "Updating..." : "Update"}
                    </Button>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default AgentAnnouncementEdit;